import { useCallback } from "react";
import { canv } from "@/canv/global";
import { eventEmitter } from "@/eventEmitter";
import { checkWidgetsForAi, createAiAnswerWidget, getWidgetsForAi } from "../../lib";
import type {
    ActiveSubMenuState,
    CreateSubMenuActions,
    EditSubMenuActions,
    SetActiveSubMenu,
} from "../../types";
import { SubMenu } from "../SubMenu/SubMenu";
import styles from "./AiAssistantMenu.module.css";
import { AiAssistantMenuContent } from "./AiAssistantMenuContent";

interface AiAssistantMenuProps {
    activeSubMenu: ActiveSubMenuState;
    setActiveSubMenu: SetActiveSubMenu;
}

export function AiAssistantMenu({ activeSubMenu, setActiveSubMenu }: AiAssistantMenuProps) {
    const handleCreateAiActionButtonClick = useCallback(
        (action: CreateSubMenuActions) => {
            const isWidgetsQuantityExceeded = checkWidgetsForAi(canv.canvasController.selected);

            if (isWidgetsQuantityExceeded) {
                return;
            }

            const widgetUIDs = getWidgetsForAi(canv.canvasController.selected);

            if (!widgetUIDs.length) {
                return;
            }

            const targetWidgetUID = createAiAnswerWidget(action, canv);

            //Для включения механизма undo/redo нужно получать стейт виджетов из getWidgetsForAi и передавать сюда
            canv.intercom.sendAiMessage("create", action, widgetUIDs, targetWidgetUID);

            canv.intercom.disableAiEvents = true;
            eventEmitter.dispatch("button.disabled", {
                aiAssistant: true,
            });

            setActiveSubMenu(null);
        },
        [setActiveSubMenu],
    );

    const handleEditAiActionButtonClick = useCallback(
        (action: EditSubMenuActions) => {
            const isWidgetsQuantityExceeded = checkWidgetsForAi(canv.canvasController.selected);

            if (isWidgetsQuantityExceeded) {
                return;
            }

            const widgetUIDs = getWidgetsForAi(canv.canvasController.selected);

            if (!widgetUIDs.length) {
                return;
            }

            //Для включения механизма undo/redo нужно получать стейт виджетов из getWidgetsForAi и передавать сюда
            canv.intercom.sendAiMessage("edit", action, widgetUIDs);

            canv.intercom.disableAiEvents = true;
            eventEmitter.dispatch("button.disabled", {
                aiAssistant: true,
            });

            setActiveSubMenu(null);
        },
        [setActiveSubMenu],
    );

    return (
        <SubMenu className={styles.wrapper} padding={"aiAssistant"} activeSubMenu={activeSubMenu}>
            <AiAssistantMenuContent
                isEditVisible={canv.canvasController.selected.length === 1}
                onCreate={handleCreateAiActionButtonClick}
                onEdit={handleEditAiActionButtonClick}
            />
        </SubMenu>
    );
}
